<template>
  <div>
    <page-header
      :actions="headerActionsConfig"
      left-side-class="col-12 col-md-7"
      :page="headerConfig"
      right-side-class="col-sm-12 col-md-5 align-items-end d-flex pb-2 justify-content-end"
    >
      <dropdown
        v-if="!isAchievementSummary"
        v-show="showDropdownActionItems"
        :items="dropdownActionItems"
        title="Acciones"
      />
    </page-header>
    <electronic-signature-cancel-section
      v-if="showCancelElectronicDocumentForm"
      :digital-signature-document-id="digitalSignatureDocumentId"
      :digital-signature-document-status-id="digitalSignatureDocumentStatusId"
      :document-type-id="documentTypeId"
      :plan-id="planId"
      @hide="hideCancelElectronicDocumentHandler"
    />
    <general-info
      :is-achievement-summary="isAchievementSummary"
      :is-electronic-signature="isElectronicSignature"
      :last-achievement="lastAchievement || {}"
      :plan-general-info="planGeneralInfo || {}"
    />
    <execution-level-legend
      v-if="isAchievementSummary"
      :legend-data="executionLevelArchieved"
      title="Leyenda de Claves para objetivos de resumen de logros"
    />
    <custom-tab class="custom-tabs">
      <custom-tab-item
        :active="tabIndex === InterventionPlanManagementTabIndex"
        :lazy="false"
        :title="
          isAchievementSummary ? 'Informe de Progreso' : 'Plan de Intervención'
        "
        @click="onChangeInfoTab(InterventionPlanManagementTabIndex)"
      >
        <custom-collapse
          id="ip-collapse"
          class="intervention-plan-collapse mt-4 px-3"
        >
          <custom-collapse-item
            :id="sections[section_indexs.Strengths].id"
            body-background-color="#F7F7F7"
            :checked="strengthsChecked"
            :expanded="sections[section_indexs.Strengths].expand"
            parent-id="ip-collapse"
            :title="sections[section_indexs.Strengths].title"
            @expandButtonClick="expand(section_indexs.Strengths)"
          >
            <div :class="isReadOnly ? 'p-0 mb-0' : 'p-2 mb-2'">
              <strengths-section
                v-if="disciplineTypeId > 0"
                ref="strengthsSection"
                :discipline-type-id="disciplineTypeId"
                :read-only="isReadOnly"
                :strengths="strengths"
                @save="strengthsSaveHandler"
                @update:strengths="strengths = $event"
              />
            </div>
          </custom-collapse-item>
          <custom-collapse-item
            :id="sections[section_indexs.Needs].id"
            body-background-color="#F7F7F7"
            :checked="needsChecked"
            :expanded="sections[section_indexs.Needs].expand"
            parent-id="ip-collapse"
            :title="sections[section_indexs.Needs].title"
            @expandButtonClick="expand(section_indexs.Needs)"
          >
            <div :class="isReadOnly ? 'p-0 mb-0' : 'p-2 mb-2'">
              <needs-section
                v-if="disciplineTypeId > 0"
                ref="needsSection"
                :discipline-type-id="disciplineTypeId"
                :needs="needs"
                :read-only="isReadOnly"
                @save="needsSaveHandler"
                @update:needs="needs = $event"
              />
            </div>
          </custom-collapse-item>
          <custom-collapse-item
            :id="sections[section_indexs.Goals].id"
            body-background-color="#F7F7F7"
            :button-text="
              goals?.length !== 0 && !isReadOnly ? 'Añadir Meta' : ''
            "
            :checked="goalsChecked"
            :expanded="sections[section_indexs.Goals].expand"
            parent-id="ip-collapse"
            :title="sections[section_indexs.Goals].title"
            @collapseItemButtonClick="addGoal()"
            @expandButtonClick="expand(section_indexs.Goals)"
          >
            <div class="p-2 mb-2">
              <div
                v-if="goals?.length === 0 && !showAddGoal"
                class="bg-white p-3 row justify-content-center"
              >
                <button
                  class="btn col-9 col-md-6 bg-light-white py-0 font-weight-normal"
                  @click="addGoal()"
                >
                  <em class="fas fa-file-plus pr-3 text-green" />
                  <span>Presione aquí para añadir meta</span>
                </button>
              </div>
              <validation-observer v-else ref="interventionPlanGoal">
                <goal-form-section
                  v-if="showAddGoal"
                  @cancel-add="cancelGoalHandler"
                  @save-goal="saveGoalHandler"
                />
                <div
                  v-for="(goal, index) in goals"
                  :key="`goals-${index}-${goal.id}`"
                >
                  <goal-form-section
                    v-if="goal.editGoal"
                    :key="`goal-form-${index}`"
                    class="mb-3"
                    :data="goal"
                    @cancel-update="cancelUpdateHandler(index)"
                    @edit-goal="editGoalHandler($event, index)"
                  />

                  <intervention-plan-goals-section
                    v-else
                    :key="`goal-${index}`"
                    :academic-year-id="planGeneralInfo?.academicYearId"
                    :data="goal"
                    :is-achievement-summary="isAchievementSummary"
                    :legend-data="executionFormData"
                    :position="index + 1"
                    :read-only="isReadOnly"
                    :submitted-summaries="submittedSummaries"
                    @delete-goal="deleteGoalHandler(index)"
                    @edit-goal="showEditGoalHandler(index)"
                    @on-change-data="changeDataObjectiveHandler"
                  />
                </div>

                <div
                  v-if="!isReadOnly"
                  class="col-12 d-flex mt-5 ml-3 justify-content-end"
                >
                  <action-button
                    i="fas fa-save"
                    variant="success"
                    @click="goalsSaveHandler"
                  >
                    Guardar
                  </action-button>
                </div>
              </validation-observer>
            </div>
          </custom-collapse-item>
          <custom-collapse-item
            :id="sections[section_indexs.CriteriaAndProcedures].id"
            body-background-color="#F7F7F7"
            :checked="criteriaAndProceduresChecked"
            :expanded="sections[section_indexs.CriteriaAndProcedures].expand"
            parent-id="ip-collapse"
            :title="sections[section_indexs.CriteriaAndProcedures].title"
            @expandButtonClick="expand(section_indexs.CriteriaAndProcedures)"
          >
            <div class="p-2 mb-2">
              <validation-observer ref="criteriaAndProceduresSection">
                <criteria-and-procedures-section
                  ref="criteriaAndProceduresItem"
                  :criteria-and-procedures="criteriaAndProcedures"
                  :read-only="isReadOnly"
                  @save="criteriaAndProceduresSaveHandler"
                  @update:criteriaAndProcedures="criteriaAndProcedures = $event"
                />
              </validation-observer>
            </div>
          </custom-collapse-item>
          <custom-collapse-item
            :id="sections[section_indexs.Specialist].id"
            body-background-color="#F7F7F7"
            :checked="specialistChecked"
            :expanded="sections[section_indexs.Specialist].expand"
            parent-id="ip-collapse"
            :title="sections[section_indexs.Specialist].title"
            @expandButtonClick="expand(section_indexs.Specialist)"
          >
            <div class="p-2 mb-2">
              <validation-observer ref="specialistSection">
                <specialist-section
                  :read-only="isReadOnly"
                  :service-specialists="planGeneralInfo.serviceSpecialists"
                  :writer-specialist="writerSpecialist"
                  :writer-specialists="planGeneralInfo.writerSpecialists"
                  @save="specialistSaveHandler"
                  @update:writerSpecialist="writerSpecialist = $event"
                />
              </validation-observer>
            </div>
          </custom-collapse-item>
        </custom-collapse>
        <template v-if="isAchievementSummary">
          <achievements-summary
            ref="goalSummary"
            :data="achievements"
            :periods="avaliablePeriods"
            :read-only="summaryReadOnly"
            :specialists="planGeneralInfo.writerSpecialists"
            @alert="validationMessage"
            @delete-achieve="deleteGoalsSummaryHandler"
            @delete-archivement="deleteArchivement"
            @editing-achievement="editingAchievementHandler"
            @save="saveGoalSummaryHandler"
          />
        </template>
      </custom-tab-item>
      <custom-tab-item
        v-if="
          (flags.isSubmitted && !isAchievementSummary) ||
            (isAchievementSummary && submittedSummaries?.length > 0)
        "
        :active="tabIndex === InterventionPlanSignatureTabIndex"
        :lazy="false"
        :title="!isAchievementSummary ? 'Firma del Plan' : 'Firma del Informe'"
        @click="onChangeInfoTab(InterventionPlanSignatureTabIndex)"
      >
        <electronic-signature-information-section
          v-if="showElectonicSignatureInformation"
          :digital-signature-document-id="digitalSignatureDocumentId"
          :is-electronic-signature="isElectronicSignature"
          :signature-participants="signatureParticipants"
        />
        <div v-else>
          <validation-observer ref="interventionSignatureSection" tag="form">
            <intervention-plan-signature-section
              ref="InterventionSignatureRef"
              :contract-id="contractId"
              :document-save="documentSave"
              :document-saved="documentSaved"
              :document-type-id="documentTypeId"
              :intervention-plan-id="planId"
              :is-achievement-summary="isAchievementSummary"
              :is-electronic-signature="isElectronicSignature"
              :signature-participants="signatureParticipants"
              :student-sie-id="planGeneralInfo?.studentSieId"
              :writer-specialist="writerSpecialist"
              @update-manuscript="handlerManuscriptParticipants"
              @update:isElectronicSignature="isElectronicSignature = $event"
              @update:signatureParticipants="signatureParticipants = $event"
            />
          </validation-observer>
        </div>
      </custom-tab-item>
      <custom-tab-item
        v-if="canAddDiagnosisInPilot && diagnosis?.studentSieId"
        :active="tabIndex === InterventionPlanDiagnosisTabIndex"
        :lazy="false"
        title="Diagnóstico"
        @click="onChangeInfoTab(InterventionPlanDiagnosisTabIndex)"
      >
        <div class="p-4">
          <diagnosis
            :is-read-only="isReadOnly"
            :item="diagnosis"
            :show-cancel="false"
            :show-save="!isReadOnly"
          />
        </div>
      </custom-tab-item>
    </custom-tab>
    <div v-if="validate">
      <custom-error
        v-if="errors.strengths.invalid"
        :message="errors.strengths.message"
      />
      <custom-error
        v-if="errors.needs.invalid"
        :message="errors.needs.message"
      />
      <custom-error
        v-if="errors.goals.invalid"
        :message="errors.goals.message"
      />
      <custom-error
        v-if="errors.criteriaAndProcedures.invalid"
        :message="errors.criteriaAndProcedures.message"
      />
      <custom-error
        v-if="errors.specialist.invalid"
        :message="errors.specialist.message"
      />
      <custom-error
        v-if="errors.executionLevel.invalid && isAchievementSummary"
        :message="errors.executionLevel.message"
      />
      <custom-error
        v-if="errors.submitAchievementSummary.invalid && isAchievementSummary"
        :message="errors.submitAchievementSummary.message"
      />
      <custom-error
        v-if="
          errors.achievement.invalid &&
            isEditingAchievement &&
            isAchievementSummary &&
            validate &&
            partialSave
        "
        :message="errors.achievement.message"
      />
      <custom-error
        v-if="
          errors.achievement.invalid &&
            isAchievementSummary &&
            validate &&
            !partialSave
        "
        :message="errors.achievement.message"
      />
    </div>
  </div>
</template>

<script>
//lib components
import PageHeader from 'PageHeader';
import { CustomCollapse, CustomCollapseItem } from 'custom-collapse';
import CustomError from 'custom-error';
import objectToFormData from 'object-to-formdata';
import ActionButton from 'ActionButton';
import Dropdown from 'dropdown';
import { CustomTab, CustomTabItem } from 'custom-tabs';

//local components
import {
  GeneralInfo,
  StrengthsSection,
  NeedsSection,
  GoalFormSection,
  InterventionPlanGoalsSection,
  CriteriaAndProceduresSection,
  SpecialistSection,
  InterventionPlanSignatureSection,
  ElectronicSignatureInformationSection,
  ElectronicSignatureCancelSection,
} from './components/intervention-plan-management';
import Diagnosis from './components/tabs/ContractDiagnosis.vue';

import {
  ExecutionLevelLegend,
  AchievementsSummary,
} from './components/achievement-summary';

//services
import {
  getPlanInfo as _getPlanInfo,
  savePlan as _savePlan,
  downloadReport as _downloadReport,
  createElectronicDocument as _createElectronicDocument,
  saveSignatureConfiguration as _saveSignatureConfiguration,
  getCodeExecutionLevelArchieved as _getCodeExecutionLevelArchieved,
  getCurrentPeriod as _getCurrentPeriod,
  saveInterventionPlanSummary as _saveInterventionPlanSummary,
  deleteArchivement as _deleteArchivement,
} from '@/services/uspqrp/intervention-plan.api.js';

import { downloadDocumentByAttachmentId as _downloadDocumentByAttachmentId } from '@/services/common/document.api.js';
import { getSysparameterByNames } from '@/services/common/sysparameter.api';

//utils
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import interventionPlanMeasure from '@/utils/constants/interventionPlanMeasure';
import InterventionPlanTabs from '@/utils/constants/interventionPlanTabs';

//constants
import SignatureDocumentStatus from '@/utils/constants/signatureDocumentStatus.js';
import rpContractDocumentTypes from '@/utils/constants/rpContractDocumentTypes.js';
import SectionType from '@/utils/constants/InterventionPlanSectionType.js';

const INTERVENTION_PLAN_MANAGEMENT_ROUTE_NAME = 'interventionPlanManagement';
const AMENDED_PLAN_HISTORY_ROUTE_NAME = 'amendedPlanHistory';

export default {
  name: 'InterventionPlanManagement',
  mixins: [alertMixin],
  components: {
    PageHeader,
    CustomCollapse,
    CustomCollapseItem,
    CustomError,
    ActionButton,
    Dropdown,
    GeneralInfo,
    StrengthsSection,
    NeedsSection,
    CriteriaAndProceduresSection,
    SpecialistSection,
    GoalFormSection,
    InterventionPlanGoalsSection,
    CustomTab,
    CustomTabItem,
    InterventionPlanSignatureSection,
    ElectronicSignatureInformationSection,
    ElectronicSignatureCancelSection,
    ExecutionLevelLegend,
    AchievementsSummary,
    Diagnosis,
  },
  data: () => ({
    isDisabled: false,
    planInfo: {},
    planGeneralInfo: {},
    strengths: [],
    needs: [],
    goals: [],
    criteriaAndProcedures: '',
    writerSpecialist: null,
    flags: {
      hasParent: false,
      hasHistory: false,
      isCurrent: false,
      isAmendment: false,
      isSubmitted: false,
    },
    validate: false,
    showAddGoal: false,
    editGoal: false,
    section_indexs: {
      Strengths: 0,
      Needs: 1,
      Goals: 2,
      CriteriaAndProcedures: 3,
      Specialist: 4,
    },
    sections: [
      {
        id: 'strengths-collapse-item',
        expand: false,
        title: 'Información de Fortalezas',
        type: SectionType.Strengths,
      },
      {
        id: 'needs-collapse-item',
        expand: false,
        title: 'Información de Necesidades',
        type: SectionType.Needs,
      },
      {
        id: 'goals-collapse-item',
        expand: false,
        title: 'Información de Metas y Objetivos',
        type: SectionType.Goals,
      },
      {
        id: 'criteria-and-procedures-collapse-item',
        expand: false,
        title: 'Criterios y Procedimientos',
        type: SectionType.CriteriaAndProcedures,
      },
      {
        id: 'specialist-collapse-item',
        expand: false,
        title: 'Información de Especialista',
        type: SectionType.Specialist,
      },
    ],
    tabIndex: InterventionPlanTabs.InterventionPlanManagement,
    isElectronicSignature: null,
    signatureParticipants: null,
    showCancelElectronicDocumentForm: false,
    signatureManuscriptParticipants: null,
    attachment: null,
    documentSave: { file: null },
    executionLevelArchieved: [],
    submittedSummaries: null,
    avaliablePeriods: [],
    achievements: [],
    summaryReadOnly: false,
    partialSave: false,
    isEditingAchievement: false,
    canAddDiagnosis: false,
    medicaidPilotCompanyIds: [],
  }),
  computed: {
    headerConfig() {
      return {
        title: !this.isAchievementSummary
          ? 'Añadir Plan de Intervención'
          : 'Informe de Progreso',
        icon: 'fas fa-clipboard-list',
        routes: [
          'Inicio',
          'Proveedores',
          'Contrato',
          !this.isAchievementSummary
            ? 'Añadir Plan de Intervención'
            : 'Informe de Progreso',
          `${this.planId ? 'Ver' : 'Añadir'}`,
        ],
      };
    },
    headerActionsConfig() {
      return [
        {
          text: 'Regresar',
          icon: 'fas fa-arrow-circle-left',
          variant: 'outline-success',
          click: () => this.$router.go(-1),
        },
        {
          text: 'Guardar',
          icon: 'fas fa-save',
          variant: 'outline-success',
          visible: this.canSaveInterventionPlan,
          click: () => this.saveHandler(true),
        },
        {
          text: 'Guardar',
          icon: 'fas fa-save',
          variant: 'outline-success',
          visible: this.canSaveSignatureConfiguration,
          click: () => this.saveSignatureConfigurationHandler(),
        },
        {
          text: 'Guardar',
          icon: 'fas fa-save',
          variant: 'outline-success',
          visible: this.canSaveProgressReport,
          click: () => this.saveInterventionPlanSummary(true),
        },
        {
          text: 'Imprimir',
          icon: 'fas fa-print text-green',
          variant: 'outline-success',
          visible: this.canPrintProgressReport,
          click: this.printHandler,
        },
        {
          text: 'Someter',
          icon: 'fas fa-flag-alt',
          variant: 'success',
          visible: this.canSubmitInterventionPlan,
          click: this.submitHandler,
        },
        {
          text: 'Generar Documento',
          icon: 'fas fa-file-signature',
          variant: 'success',
          visible: this.canGenerateElectronicDocument,
          click: this.generateElectronicDocumentHandler,
        },
        {
          text: 'Cancelar Firma Electrónica',
          icon: 'fas fa-times-circle text-red',
          variant: 'outline-danger',
          visible:
            this.isAchievementSummary && this.canCancelElectronicDocument,
          click: this.cancelElectronicDocumentHandler,
        },
      ];
    },
    dropdownActionItems() {
      return [
        {
          label: 'Enmendar Plan',
          icon: 'fas fa-files-medical text-green',
          visible: this.canAmendInterventionPlan,
          click: this.amendHandler,
        },
        {
          label: 'Historial de Plan Enmendado',
          icon: 'fas fa-history text-green',
          visible: this.canViewHistory,
          click: this.goToHistoryHandler,
        },
        {
          label: 'Cancelar Firma Electrónica',
          icon: 'fas fa-times-circle text-red',
          visible: this.canCancelElectronicDocument,
          click: this.cancelElectronicDocumentHandler,
        },
        {
          label: this.isDownloabledocument ? 'Descargar' : 'Imprimir',
          icon: 'fas fa-print text-green',
          visible: this.canPrintInterventionPlan,
          click: this.printHandler,
        },
      ];
    },
    contractId() {
      return Number(this.$route.params?.contractId);
    },
    planId() {
      return this.$route.params?.planId
        ? Number(this.$route.params?.planId)
        : null;
    },
    contractNumber() {
      return this.planHeaderInfo?.contractNumber;
    },
    disciplineTypeId() {
      return this.planGeneralInfo?.requestServiceDisciplineTypeId;
    },
    isNewPlan() {
      return Boolean(this.$route.query?.isNewPlan);
    },
    isSubmitable() {
      return Boolean(this.$route.params?.isSubmitable);
    },
    canSaveInterventionPlan() {
      return !this.flags.isSubmitted && !this.isAchievementSummary;
    },
    canSubmitInterventionPlan() {
      return (
        this.isSubmitable &&
        !this.flags.isSubmitted &&
        this.planId !== null &&
        !this.isAchievementSummary
      );
    },
    canSaveProgressReport() {
      return (
        this.tabIndex === this.InterventionPlanManagementTabIndex &&
        this.isAchievementSummary
      );
    },
    isDownloabledocument() {
      return (
        this.isElectronicSignature &&
        this.flags.isSubmitted &&
        this.documentSaved
      );
    },
    canPrintInterventionPlan() {
      return this.planId !== null;
    },
    canPrintProgressReport() {
      if (this.isAchievementSummary) {
        return this.achievements.length > 0;
      }
      return false;
    },
    canAmendInterventionPlan() {
      const validStatuses = [
        SignatureDocumentStatus.DocNotGenerated,
        SignatureDocumentStatus.Signed,
      ];
      return (
        this.flags.isSubmitted &&
        (!this.isElectronicSignature ||
          validStatuses.includes(this.digitalSignatureDocumentStatusId))
      );
    },
    canViewHistory() {
      return this.flags.isAmendment && this.flags.isSubmitted;
    },
    canSaveSignatureConfiguration() {
      const validStatuses = [SignatureDocumentStatus.DocNotGenerated];
      return (
        this.tabIndex === this.InterventionPlanSignatureTabIndex &&
        this.flags.isSubmitted &&
        this.isElectronicSignature !== null &&
        (!this.isElectronicSignature ||
          validStatuses.includes(this.digitalSignatureDocumentStatusId))
      );
    },
    canGenerateElectronicDocument() {
      const validStatuses = [SignatureDocumentStatus.DocNotGenerated];
      return (
        this.tabIndex === this.InterventionPlanSignatureTabIndex &&
        this.flags.isSubmitted &&
        this.isElectronicSignature === true &&
        validStatuses.includes(this.digitalSignatureDocumentStatusId)
      );
    },
    canCancelElectronicDocument() {
      const validStatuses = [SignatureDocumentStatus.InSigningProcess];
      return (
        this.isElectronicSignature === true &&
        validStatuses.includes(this.digitalSignatureDocumentStatusId) &&
        this.showCancelElectronicDocumentForm === false
      );
    },
    showDropdownActionItems() {
      return (
        this.canAmendInterventionPlan ||
        this.canPrintInterventionPlan ||
        this.canViewHistory ||
        this.canCancelElectronicDocument
      );
    },
    showElectonicSignatureInformation() {
      const validStatuses = [
        SignatureDocumentStatus.InSigningProcess,
        SignatureDocumentStatus.Signed,
      ];
      return (
        this.isElectronicSignature === true &&
        validStatuses.includes(this.digitalSignatureDocumentStatusId) &&
        (this.signatureParticipants?.length || 0) > 0
      );
    },
    selectedGoals() {
      return (
        this.goals.map((g) => {
          const goal = { ...g };
          delete goal.id;
          delete goal.editGoal;
          goal.objectives = goal.objectives.map((o) => {
            const measurement = o.measurement?.id || o.measureCodeId;
            return {
              description: o.description,
              measureCodeId: measurement,
              measureAmt1: Number(o.percent) || Number(o.measureAmt1),
              measureAmt2:
                Number(o.measureAmt2) > measurement !=
                interventionPlanMeasure.Percent
                  ? Number(o.measureAmt2)
                  : 0,
            };
          });
          return goal;
        }) || []
      );
    },
    strengthsChecked() {
      return (this.strengths?.length || 0) > 0;
    },
    needsChecked() {
      return (this.needs?.length || 0) > 0;
    },
    goalsChecked() {
      return (this.goals?.length || 0) > 0;
    },
    criteriaAndProceduresChecked() {
      return (this.criteriaAndProcedures?.length || 0) > 0;
    },
    specialistChecked() {
      return (this.writerSpecialist?.id || 0) > 0;
    },
    isReadOnly() {
      return !this.canSaveInterventionPlan;
    },
    errors(executionLevelLegend = 0) {
      return {
        strengths: {
          invalid: (this.strengths?.length || 0) === 0,
          message: 'Favor de añadir información de Fortalezas.',
        },
        needs: {
          invalid: (this.needs?.length || 0) === 0,
          message: 'Favor de añadir información de Necesidades.',
        },
        criteriaAndProcedures: {
          invalid: (this.criteriaAndProcedures?.length || 0) === 0,
          message: 'Favor escriba los criterios y procedimientos.',
        },
        specialist: {
          invalid: (this.writerSpecialist?.id || 0) === 0,
          message:
            'Favor añadir la información relacionada a los especialistas correspondiente.',
        },
        goals: {
          invalid:
            this.goals?.length === 0 ||
            this.goals.some((g) => g.objectives.length === 0),
          message: 'Favor de añadir información de metas y objetivos.',
        },
        electronicDocument: {
          invalid:
            !this.signatureParticipants?.some((p) => p.isPrimary === true) ||
            false,
          message: 'Favor seleccionar el participante firmante.',
        },
        achievement: {
          invalid: !(this.achievements && this.achievements.length),
          message:
            'Favor añadir el resumen de logros del periodo correspondiente.',
        },
        executionLevel: {
          invalid: executionLevelLegend <= 0,
          message:
            'Favor agregar el nivel de ejecución logrado de al menos uno de los objetivos.',
        },
        submitAchievementSummary: {
          invalid: false,
          message:
            'Favor registrar el nivel de ejecución logrado de todos los objetivos.',
        },
      };
    },
    InterventionPlanManagementTabIndex() {
      return InterventionPlanTabs.InterventionPlanManagement;
    },
    InterventionPlanSignatureTabIndex() {
      return InterventionPlanTabs.InterventionPlanSignature;
    },
    InterventionPlanDiagnosisTabIndex() {
      return InterventionPlanTabs.InterventionPlanDiagnosis;
    },
    documentTypeId() {
      return this.isAchievementSummary
        ? rpContractDocumentTypes.ProgressReport
        : rpContractDocumentTypes.InterventionPlan;
    },
    digitalSignatureDocumentId() {
      return !this.isAchievementSummary
        ? this.planGeneralInfo?.digitalSignatureDocumentId
        : this.lastAchievement?.digitalSignatureDocumentId;
    },
    digitalSignatureDocumentStatusId() {
      return !this.isAchievementSummary
        ? this.planGeneralInfo?.digitalSignatureDocumentStatusId
        : this.lastAchievement?.digitalSignatureDocumentStatusId;
    },
    isAchievementSummary() {
      const paramValue = this.$route.params?.isAchievementSummary;
      if (!paramValue) return false;
      if (typeof paramValue === 'boolean') return paramValue;
      return paramValue === 'true' || paramValue === '1';
    },
    executionFormData() {
      return {
        executionLevels: this.executionLevelArchieved,
        period: this.avaliablePeriods,
      };
    },
    selectedPeriodsToSubmit() {
      let periods = [];
      this.avaliablePeriods.forEach((item) => {
        var add = true;
        this.goals.forEach((goal) => {
          goal.objectives.forEach((objetive) => {
            if (
              objetive.executionLevelArchieved.filter(
                (x) => x.period.periodId == item.periodId
              ).length > 0
            ) {
              add;
            } else {
              add = false;
            }
          });
        });
        let isPeriodSubmitted =
          this.achievements.find((x) => x.period.periodId == item.periodId) ==
          undefined;
        if (add && isPeriodSubmitted) periods.push(item);
      });
      return periods;
    },
    lastAchievement() {
      return [...(this.achievements ?? [])].sort((a, b) => {
        if (a.academicYear.value !== b.academicYear.value) {
          return b.academicYear.value - a.academicYear.value;
        }
        return b.period.value - a.period.value;
      })[0];
    },
    diagnosis() {
      return {
        studentSieId: this.planGeneralInfo?.studentSieId,
        disciplineTypeId: this.disciplineTypeId,
      };
    },
    canAddDiagnosisInPilot() {
      return (
        this.canAddDiagnosis &&
        this.medicaidPilotCompanyIds.some(
          (x) => x === this.planGeneralInfo?.companyId
        )
      );
    },
  },
  async mounted() {
    await this.onLoad();
    await this.getParams();
  },
  methods: {
    async getParams() {
      const { data } = await getSysparameterByNames({
        parameterNames: ['MedicaidPilotCompanyIds', 'CanAddDiagnosisRp'],
      });

      this.canAddDiagnosis =
        data
          ?.find((x) => x.name === 'CanAddDiagnosisRp')
          ?.staticValue?.toLowerCase() == 'true' ?? false;

      this.medicaidPilotCompanyIds =
        data
          ?.find((x) => x.name === 'MedicaidPilotCompanyIds')
          ?.staticValue?.split(',')
          .map((x) => parseInt(x, 10)) ?? [];
    },
    async onLoad() {
      await this.getInterventionPlanHandler();
      if (this.isAchievementSummary) {
        await this.getCodeExecutionLevelArchieved();
        await this.getCurrentPeriod();
        this.expandSummarySections();
      }
    },
    expandSummarySections() {
      // Usar el enum y la propiedad type en vez de comparar por título
      this.sections = this.sections.map((section) => {
        if (
          section.type === SectionType.Goals ||
          section.type === SectionType.AchievementsSummary
        ) {
          return { ...section, expand: true };
        }
        return { ...section, expand: false };
      });
    },
    async goToHistoryHandler() {
      this.$router.push({
        name: AMENDED_PLAN_HISTORY_ROUTE_NAME,
        params: {
          planId: this.planId,
          contractId: this.contractId,
          from: 'interventionPlanManagement',
        },
      });
    },
    async getInterventionPlanHandler() {
      const response = (await _getPlanInfo(this.contractId, this.planId)).data;
      this.planInfo = response;
      this.planGeneralInfo = response.planGeneralInfo;
      this.strengths = response.strengths.map((s) => ({
        id: s.id,
        interventionId: s.interventionId,
        name: s.name,
      }));
      this.needs = response.needs.map((s) => ({
        id: s.id,
        interventionId: s.interventionId,
        name: s.name,
      }));
      this.goals = response.goals.map((g) => ({
        ...g,
        objectives: g.objectives.map((o) => ({
          ...o,
          executionLevelArchieved: o.archievements
            .map((a) => ({
              executionLevel: a.executionLevelArchieved,
              period: this.mapPeriod(a.period),
            }))
            .sort((a, b) => a.period.order - b.period.order),
        })),
      }));
      this.criteriaAndProcedures = response.criteriaAndProcedures;
      this.writerSpecialist = response.planGeneralInfo.writerSpecialist;
      if (
        !this.writerSpecialist &&
        response.planGeneralInfo.writerSpecialists.length === 1
      ) {
        this.writerSpecialist = response.planGeneralInfo.writerSpecialists[0];
      }
      this.flags = {
        hasParent: response.planGeneralInfo.hasParent,
        hasHistory: response.planGeneralInfo.hasHistory,
        isCurrent: response.planGeneralInfo.isCurrent,
        isAmendment: response.planGeneralInfo.isAmendment,
        isSubmitted: response.planGeneralInfo.isSubmitted,
      };
      if (!this.isAchievementSummary) {
        this.isElectronicSignature =
          response.planGeneralInfo.isElectronicSignature;
      }

      if (response.document != null) {
        this.documentSave = {
          name: response.document.filename,
          documentType: response.document.documentTypeId,
          documentId: response.document.documentId,
          readOnly: true,
          inServer: true,
          file: null,
        };
        this.documentSaved = true;
      } else {
        this.documentSave = { documentId: null, name: null };
      }

      if (this.isAchievementSummary) {
        if (response.documentPlanArchievement != null) {
          this.documentSave = {
            name: response.documentPlanArchievement.filename,
            documentType: response.documentPlanArchievement.documentTypeId,
            documentId: response.documentPlanArchievement.documentId,
            readOnly: true,
            inServer: true,
            file: null,
          };
          this.documentSaved = true;
        } else {
          this.documentSave = { documentId: null, name: null };
        }
      }

      if (response.archievements && response.archievements.length > 0) {
        this.achievements = response.archievements
          .map((a) => ({
            achievement: a.description,
            sessions: a.sessions,
            id: a.id,
            period: this.mapPeriod(a.period),
            specialist: a.specialist || { name: '' },
            isElectronicSignature: a.isElectronicSignature,
            digitalSignatureDocumentId: a.digitalSignatureDocumentId,
            digitalSignatureDocumentStatusId:
              a.digitalSignatureDocumentStatusId,
            digitalSignatureDocumentStatus: a.digitalSignatureDocumentStatus,
          }))
          .sort((a, b) => a.period.order - b.period.order);

        this.submittedSummaries = this.achievements.map((x) => ({
          period: x.period.periodId,
          academicYearId: x.period.academicYearId,
        }));
        this.isElectronicSignature = this.lastAchievement?.isElectronicSignature;
      }
    },
    async saveInterventionPlanHandler(payload, showConfirmMessage = false) {
      await _savePlan(payload)
        .then((res) => {
          if (this.planId === null) {
            let planId = res.data;
            this.$router.replace({
              name: INTERVENTION_PLAN_MANAGEMENT_ROUTE_NAME,
              params: {
                contractId: this.contractId,
                isSubmitable: this.isSubmitable,
                planId: planId,
              },
            });
          }
          if (showConfirmMessage) {
            let action = this.$options.filters.toBoolean(
              payload.get('isSubmitted')
            )
              ? 'sometido'
              : 'guardado';
            this.ShowToast(
              'Confirmación',
              `El plan de intervención ha sido ${action} exitosamente.`,
              'success'
            );
          }
        })
        .catch((error) => {
          this.ShowToast(
            'Alerta',
            error?.response?.data?.message ?? 'Ha ocurrido un error.',
            'error'
          );
        });
    },
    async saveHandler(showConfirmMessage = false) {
      this.validate = false;
      let payload = this.fillPayload();
      await this.saveInterventionPlanHandler(payload, showConfirmMessage);
      if (this.criteriaAndProceduresChecked) {
        this.$refs.criteriaAndProceduresItem.setFlags();
      }
    },
    async submitHandler() {
      this.validate = false;
      if (
        this.errors.strengths.invalid ||
        this.errors.needs.invalid ||
        this.errors.criteriaAndProcedures.invalid ||
        this.errors.specialist.invalid ||
        this.errors.goals.invalid
      ) {
        this.validate = true;
        this.validationMessage();
      } else {
        let payload = this.fillPayload(true);
        await this.saveInterventionPlanHandler(payload, true);
        await this.getInterventionPlanHandler();
        if (this.criteriaAndProceduresChecked) {
          this.$refs.criteriaAndProceduresItem.setFlags();
        }
      }
    },
    async amendHandler() {
      const answer = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea enmendar el plan de intervención?`,
        'Si',
        'No'
      );
      if (!answer) return;
      this.$router.replace({
        name: INTERVENTION_PLAN_MANAGEMENT_ROUTE_NAME,
        params: {
          contractId: this.contractId,
          isSubmitable: this.isSubmitable,
          planId: null,
        },
      });
      const payload = this.fillPayload(false, true);
      await this.saveInterventionPlanHandler(payload).then(async () => {
        this.flags.isAmendment = true;
        this.flags.isSubmitted = false;
        if (this.criteriaAndProceduresChecked) {
          this.$refs.criteriaAndProceduresItem.setFlags();
        }
      });
    },
    async printHandler() {
      if (this.isDownloabledocument) {
        if (this.documentSave?.documentId) {
          _downloadDocumentByAttachmentId(this.documentSave?.documentId).catch(
            (err) => {
              this.ShowToast(
                'Alerta',
                err.response.data.message || 'error',
                'error'
              );
            }
          );
        }
      } else {
        let report = null;
        if (this.isAchievementSummary) {
          report = `progressreport/${this.contractId}/${this.planId}`;
        } else {
          report = `interventionplanreport/${this.contractId}/${this.planId}`;
        }
        await _downloadReport(report).catch(() => {
          this.ShowToast('', 'El documento no existe.', 'error');
        });
      }
    },
    async strengthsSaveHandler() {
      await this.saveHandler();
      this.expand(this.section_indexs.Needs);
    },
    async needsSaveHandler() {
      await this.saveHandler();
      this.expand(this.section_indexs.Goals);
    },
    async criteriaAndProceduresSaveHandler() {
      const isValid = await this.$refs.criteriaAndProceduresSection.validate();
      if (!isValid) {
        this.validationMessage();
        return;
      }
      await this.saveHandler();
      this.expand(this.section_indexs.Specialist);
    },
    async specialistSaveHandler() {
      const isValid = await this.$refs.specialistSection.validate();
      if (!isValid) {
        this.validationMessage;
        return;
      }
      await this.saveHandler();
    },
    async goalsSaveHandler() {
      const hasObjectives = this.goals.every(
        (goal) => goal.objectives && goal.objectives.length > 0
      );
      if (!hasObjectives) {
        this.ShowToast(
          'Información Incompleta',
          'Cada meta debe tener al menos un objetivo.',
          'error'
        );
        return;
      }
      await this.saveHandler();
      this.expand(this.section_indexs.CriteriaAndProcedures);
    },
    addGoal() {
      this.showAddGoal = true;
    },
    async saveGoalHandler(goal) {
      const isValid = await this.$refs.interventionPlanGoal.validate();
      if (!isValid) {
        this.validationMessage();
        return;
      }
      const data = {
        id: Math.random() * 10,
        editGoal: false,
        ...goal,
      };
      this.goals.push(data);
      this.cancelGoalHandler();
    },
    cancelGoalHandler() {
      this.showAddGoal = false;
    },
    async cancelUpdateHandler(index) {
      this.goals[index].editGoal = false;
      await this.$forceUpdate();
    },
    async showEditGoalHandler(index) {
      this.goals.forEach((o) => {
        o.editGoal = false;
      });
      this.goals[index].editGoal = !this.goals[index].editGoal;
      await this.$forceUpdate();
    },
    editGoalHandler(goal, index) {
      this.goals[index] = goal;
      this.cancelUpdateHandler(index);
    },
    deleteGoalHandler(index) {
      this.goals.splice(index, 1);
    },
    changeDataObjectiveHandler(goal) {
      const index = this.goals.findIndex((g) => g.id == goal.id);
      this.goals[index] = goal;
      localStorage.setItem('goals', JSON.stringify(this.goals));
      this.goals = JSON.parse(localStorage.getItem('goals'));
    },
    fillPayload(isSubmitted = false, isAmendment = false) {
      const payload = {
        id: isAmendment ? null : this.planId,
        parentId: !isAmendment ? null : this.planId,
        academicYearId: this.planGeneralInfo?.academicYearId,
        contractId: this.contractId,
        isSubmitted: isSubmitted,
        isAmendment: isAmendment,
        studentSieId: this.planGeneralInfo?.studentSieId,
        writerSpecialistId: this.writerSpecialist?.id,
        strengths: this.strengths,
        needs: this.needs,
        criteriaAndProcedures: this.criteriaAndProcedures,
        goals: this.selectedGoals,
        disciplineTypeId: this.disciplineTypeId,
      };

      const params = objectToFormData(
        { ...payload },
        { indices: true, nullsAsUndefineds: true }
      );

      return params;
    },
    fillSignatureConfigurationPayload() {
      let participants = [];

      if (this.isElectronicSignature) {
        participants = this.signatureParticipants.filter(
          (x) => x.isPrimary === true
        );
      } else {
        participants = this.signatureManuscriptParticipants.filter(
          (x) => x.isPrimary === true
        );
      }
      const payload = {
        planId: this.planId,
        isElectronicSignature: this.isElectronicSignature,
        participants: participants,
        attachment: this.attachment,
        documentTypeId: this.documentTypeId,
      };

      const params = objectToFormData(
        { ...payload },
        { indices: true, nullsAsUndefineds: true }
      );

      if (!this.isElectronicSignature) {
        if (this.attachment != null) {
          if (this.attachment && this.attachment.file) {
            params.append(
              `attachment`,
              this.attachment.file,
              this.attachment.file.name
            );
          }
        } else {
          this.ShowToast(
            'Alerta',
            'Debe adjuntar un documento de plan de intervencion firmado.',
            'error'
          );
          return null;
        }

        if (participants.length === 0) {
          this.ShowToast(
            'Alerta',
            'Debe seleccionar al menos un participante para la firma.',
            'error'
          );
          return null;
        }
      }
      return params;
    },
    validationMessage() {
      this.ShowToast(
        'Información Incompleta',
        'Favor completar la información solicitada para poder continuar.',
        'error'
      );
    },
    expand(sectionIndex) {
      // Colapsar todas las secciones
      this.sections = this.sections.map((section, index) => ({
        ...section,
        expand: index === sectionIndex,
      }));
    },
    onChangeInfoTab(index) {
      this.tabIndex = index;
    },
    async saveSignatureConfigurationHandler() {
      if (this.planId) {
        const payload = this.fillSignatureConfigurationPayload();
        await _saveSignatureConfiguration(payload)
          .then(async (res) => {
            if (res) {
              this.ShowToast(
                'Alerta',
                'Firma guardada exitosamente.',
                'success'
              );
              await this.onLoad();
            }
          })
          .catch(() =>
            this.ShowToast('Alerta', 'Ha ocurrido un error.', 'error')
          );
      }
    },
    async generateElectronicDocumentHandler() {
      const answer = await this.ShowCancelModal(
        'Confirmación',
        '¿Está seguro que desea generar documento para firma electrónica?',
        'Si',
        'No'
      );
      if (!answer) return;
      if (this.errors.electronicDocument.invalid) {
        this.ShowToast(
          'Alerta',
          this.errors.electronicDocument.message,
          'error'
        );
        return;
      }
      if (this.planId) {
        const payload = this.fillSignatureConfigurationPayload();
        await _saveSignatureConfiguration(payload)
          .then(async (res) => {
            if (res) {
              const params = {
                planId: this.planId,
                documentTypeId: this.documentTypeId,
              };
              await _createElectronicDocument(params)
                .then(async (res) => {
                  if (res) {
                    await this.onLoad();
                  }
                })
                .catch(() =>
                  this.ShowToast('Alerta', 'Ha ocurrido un error.', 'error')
                );
            }
          })
          .catch(() =>
            this.ShowToast('Alerta', 'Ha ocurrido un error.', 'error')
          );
      }
    },
    async cancelElectronicDocumentHandler() {
      this.showCancelElectronicDocumentForm = true;
    },
    async hideCancelElectronicDocumentHandler(reload = false) {
      this.showCancelElectronicDocumentForm = false;
      if (reload) {
        await this.onLoad();
      }
    },
    handlerManuscriptParticipants(data) {
      this.attachment = data.document;
      this.signatureManuscriptParticipants = data.participants;

      // Validar si el documento tiene contenido
      if (data.document && data.document.file) {
        this.documentSave = {
          name: data.document.name,
          readOnly: false,
          inServer: false,
          file: data.document.file,
        };
      }
    },
    async getCodeExecutionLevelArchieved() {
      if (this.isAchievementSummary) {
        const { data } = await _getCodeExecutionLevelArchieved();
        this.executionLevelArchieved = data;
      }
    },
    mapPeriod(period) {
      const id = Number(period.value);
      const periodName =
        period.name.charAt(0).toUpperCase() + period.name.slice(1);
      let mappedObj = {
        name: `${periodName}`,
        periodId: id,
        academicYearId: period.id,
      };
      return mappedObj;
    },
    async getCurrentPeriod() {
      const { data } = await _getCurrentPeriod();
      this.avaliablePeriods = data.periods.map((p) => {
        return this.mapPeriod(p);
      });
    },
    async saveInterventionPlanSummary(isSave = true) {
      this.partialSave = isSave;
      this.validate = true;
      let objectiveArchievements = [];
      let goalObjectives = this.goals.reduce(
        (acc, goal) => acc + (goal.objectives ? goal.objectives.length : 0),
        0
      );

      this.goals.forEach((goal) => {
        goal.objectives.forEach((objective) => {
          objectiveArchievements = objectiveArchievements.concat(
            (objective.executionLevelArchieved || []).map((o) => ({
              objectiveId: objective.id,
              executionLevelArchievedId: o.executionLevel.id,
              period: o.period.periodId,
              academicYearId: o.period.academicYearId,
            }))
          );
        });
      });

      this.errors.executionLevel.invalid = objectiveArchievements.length === 0;
      if (this.errors.executionLevel.invalid && isSave) {
        this.validationMessage();
        return;
      }

      this.errors.achievement.invalid = this.achievements.length === 0;
      this.$forceUpdate();

      if (this.errors.achievement.invalid && this.isEditingAchievement) {
        await this.$refs.goalSummary.$refs.goalSummary.validate();
        this.validationMessage();
        return;
      } else {
        this.errors.achievement.invalid = false;
      }

      if (!isSave) {
        const answer = await this.ShowCancelModal(
          'Confirmación',
          `¿Está seguro que desea someter el resumen de logros del estudiante <b>${this.planGeneralInfo.studentFullName}</b>?`,
          'Si',
          'No'
        );

        if (!answer) return;

        if (objectiveArchievements.length < goalObjectives && !isSave) {
          this.errors.submitAchievementSummary.invalid = true;
          this.achievements = [];
          this.$forceUpdate();
          this.validationMessage();
          return;
        }
        this.errors.achievement.invalid = this.achievements.length === 0;
        this.$forceUpdate();
        if (this.errors.achievement.invalid) {
          this.validationMessage();
          return;
        }
      }

      const params = objectToFormData(
        {
          objectiveArchievements,
          planId: this.planId,
          archievements: this.achievements.map((a) => ({
            description: a.achievement,
            sessions: Number(a.sessions ?? null),
            period: a.period.periodId,
            academicYearId: a.period.academicYearId,
            specialistId: a.specialist.supervisedSpecialistId,
          })),
        },
        { indices: true }
      );
      await this.addInterventionPlanSummary(params, isSave);
      this.getInterventionPlanHandler();
    },
    async addInterventionPlanSummary(params, isSave) {
      await _saveInterventionPlanSummary(this.planId, params)
        .then(() => {
          let action = isSave ? 'guardado' : 'sometido';
          this.ShowToast(
            'Confirmación',
            `El Informe de Progreso ha sido ${action} exitosamente.`,
            'success'
          );
          this.summaryReadOnly = !isSave;
          this.submittedSummaries = this.achievements.map((x) => ({
            period: x.period.periodId,
            academicYearId: x.period.academicYearId,
          }));
        })
        .catch((err) => {
          if (err.response != null)
            this.ShowToast(
              'Alerta',
              err.response.data.message || 'error',
              'error',
              5000
            );
        });
    },
    deleteGoalsSummaryHandler(id) {
      const idx = this.achievements.findIndex((a) => a.id == id);
      this.achievements.splice(idx, 1);
    },
    async deleteArchivement(id) {
      const { data: isDeleted } = await _deleteArchivement(id);
      if (isDeleted) {
        this.submittedSummaries = [];
        const idx = this.achievements.findIndex((a) => a.id == id);
        if (idx >= 0) {
          this.achievements.splice(idx, 1);
        }
        this.ShowToast(
          'Confirmación',
          `El Resumen de Logro ha sido eliminado exitosamente.`,
          'success'
        );
        //this.$router.go(0);
      }
    },
    async saveGoalSummaryHandler(achievement) {
      const idx = this.achievements.findIndex((a) => a.id == achievement.id);
      if (idx >= 0) {
        this.achievements.splice(idx, 1, achievement);
      } else {
        this.achievements.push(achievement);
        this.achievements.sort((a, b) => a.period.order - b.period.order);
      }
      if (this.achievements.length > 0) {
        this.errors.achievement.invalid = false;
        this.$forceUpdate();
      }
      this.saveInterventionPlanSummary(false);
    },
    async editingAchievementHandler(editing) {
      this.isEditingAchievement = editing;
      this.errors.achievement.invalid = false;
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/shared/scss/config/_colors.scss';

::v-deep .intervention-plan-collapse {
  .card-header {
    background-color: map-get($colors, 'white');
    border-bottom: 1px solid #e1e1e1;
    border-top: 1px solid #e1e1e1;
    .add-button {
      margin-top: 0.2rem;
      @media only screen and (max-width: 768px) {
        margin-top: 0.5rem;
        float: none !important;
      }
    }
  }
  .card-body {
    box-shadow: none;
    padding: 0.8rem;
  }
}
::v-deep.intervention-plan-continer {
  .mobile-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-direction: row;
    flex-wrap: wrap;
  }
}
</style>
